import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";

import translationNL from './i18next/nl.json';

// the translations
const resources = {
  nl: {
    translation: translationNL
  }
};

i18n
  .use(reactI18nextModule as any) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "nl"
  });

export default i18n;